// extracted by mini-css-extract-plugin
module.exports = {"title":"Followers_title__1qdiR"};